/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { AppointmentBlocker } from '../model/appointmentBlocker';
// @ts-ignore
import { AppointmentSerializerDetail } from '../model/appointmentSerializerDetail';
// @ts-ignore
import { AppointmentType } from '../model/appointmentType';
// @ts-ignore
import { AppointmentTypeFilter } from '../model/appointmentTypeFilter';
// @ts-ignore
import { AvailabilitySchedule } from '../model/availabilitySchedule';
// @ts-ignore
import { AvailabilityScheduleCreateRequest } from '../model/availabilityScheduleCreateRequest';
// @ts-ignore
import { AvailabilityWindow } from '../model/availabilityWindow';
// @ts-ignore
import { AvailabilityWindowCreateRequest } from '../model/availabilityWindowCreateRequest';
// @ts-ignore
import { AvailabilityWindowUpdateRequest } from '../model/availabilityWindowUpdateRequest';
// @ts-ignore
import { BackgroundEventsResult } from '../model/backgroundEventsResult';
// @ts-ignore
import { BookingConfig } from '../model/bookingConfig';
// @ts-ignore
import { CalendarAppointmentBook } from '../model/calendarAppointmentBook';
// @ts-ignore
import { CalendarAppointmentBookGet } from '../model/calendarAppointmentBookGet';
// @ts-ignore
import { CalendarAppointmentVideoCallLinkResponse } from '../model/calendarAppointmentVideoCallLinkResponse';
// @ts-ignore
import { CalendarBlockerCreate } from '../model/calendarBlockerCreate';
// @ts-ignore
import { CalendarBlockerInitial } from '../model/calendarBlockerInitial';
// @ts-ignore
import { CalendarFilterResponse } from '../model/calendarFilterResponse';
// @ts-ignore
import { CalendarRequest } from '../model/calendarRequest';
// @ts-ignore
import { CalendarResponse } from '../model/calendarResponse';
// @ts-ignore
import { ConflictingAppointment } from '../model/conflictingAppointment';
// @ts-ignore
import { ListIds } from '../model/listIds';
// @ts-ignore
import { PaginatedAppointmentListList } from '../model/paginatedAppointmentListList';
// @ts-ignore
import { PatchedAppointmentBlockerUpdate } from '../model/patchedAppointmentBlockerUpdate';
// @ts-ignore
import { PatchedAvailabilityScheduleUpdateRequest } from '../model/patchedAvailabilityScheduleUpdateRequest';
// @ts-ignore
import { PatchedAvailabilityWindowUpdateRequest } from '../model/patchedAvailabilityWindowUpdateRequest';
// @ts-ignore
import { PatchedCalendarAppointmentUpdate } from '../model/patchedCalendarAppointmentUpdate';
// @ts-ignore
import { PlannerBookingViewRequest } from '../model/plannerBookingViewRequest';
// @ts-ignore
import { PlannerCalendarViewRequest } from '../model/plannerCalendarViewRequest';
// @ts-ignore
import { PlannerCalendarViewResponse } from '../model/plannerCalendarViewResponse';
// @ts-ignore
import { PlannerFilterRequest } from '../model/plannerFilterRequest';
// @ts-ignore
import { PlannerFilterViewResponse } from '../model/plannerFilterViewResponse';
// @ts-ignore
import { PlannerInitialConsultationCheckRequest } from '../model/plannerInitialConsultationCheckRequest';
// @ts-ignore
import { PlannerInitialConsultationCheckResponse } from '../model/plannerInitialConsultationCheckResponse';
// @ts-ignore
import { PlannerViewRequest } from '../model/plannerViewRequest';
// @ts-ignore
import { ScheduleCreateResult } from '../model/scheduleCreateResult';
// @ts-ignore
import { ScheduleSplitRequest } from '../model/scheduleSplitRequest';
// @ts-ignore
import { TreatmentType } from '../model/treatmentType';
// @ts-ignore
import { TreatmentTypeFilter } from '../model/treatmentTypeFilter';
// @ts-ignore
import { WeeklyUtilizationResult } from '../model/weeklyUtilizationResult';
// @ts-ignore
import { WindowToScheduleRequest } from '../model/windowToScheduleRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    BookingServiceInterface
} from './booking.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class BookingService extends BaseService implements BookingServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Which rows the list\&#39;s first page holds for the same filters, ordering and page size, without building them.
     * @param appointmentStatusIn 
     * @param aroundNow When true and no date range is set, the first page starts at the next upcoming appointment. Use previous/next cursors to load future and past. Ignored when a cursor or start_date_from/start_date_to is present.
     * @param pageSize As many as the list has loaded
     * @param patientIn 
     * @param practiceIn 
     * @param search 
     * @param sessionTypeIn 
     * @param startDateFrom Inclusive.
     * @param startDateTo Inclusive.
     * @param therapistIn 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingAppointmentsIdsRetrieve(appointmentStatusIn?: Array<'ATTENDED' | 'BOOKED' | 'CANCELLED' | 'CANCELLED_LATE' | 'CANCELLED_PENDING' | 'RESERVED'>, aroundNow?: boolean, pageSize?: number, patientIn?: Array<number>, practiceIn?: Array<number>, search?: string, sessionTypeIn?: Array<'INDIVIDUAL_SESSION' | 'INITIAL_CONSULTATION'>, startDateFrom?: string, startDateTo?: string, therapistIn?: Array<number>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ListIds>;
    public bookingAppointmentsIdsRetrieve(appointmentStatusIn?: Array<'ATTENDED' | 'BOOKED' | 'CANCELLED' | 'CANCELLED_LATE' | 'CANCELLED_PENDING' | 'RESERVED'>, aroundNow?: boolean, pageSize?: number, patientIn?: Array<number>, practiceIn?: Array<number>, search?: string, sessionTypeIn?: Array<'INDIVIDUAL_SESSION' | 'INITIAL_CONSULTATION'>, startDateFrom?: string, startDateTo?: string, therapistIn?: Array<number>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ListIds>>;
    public bookingAppointmentsIdsRetrieve(appointmentStatusIn?: Array<'ATTENDED' | 'BOOKED' | 'CANCELLED' | 'CANCELLED_LATE' | 'CANCELLED_PENDING' | 'RESERVED'>, aroundNow?: boolean, pageSize?: number, patientIn?: Array<number>, practiceIn?: Array<number>, search?: string, sessionTypeIn?: Array<'INDIVIDUAL_SESSION' | 'INITIAL_CONSULTATION'>, startDateFrom?: string, startDateTo?: string, therapistIn?: Array<number>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ListIds>>;
    public bookingAppointmentsIdsRetrieve(appointmentStatusIn?: Array<'ATTENDED' | 'BOOKED' | 'CANCELLED' | 'CANCELLED_LATE' | 'CANCELLED_PENDING' | 'RESERVED'>, aroundNow?: boolean, pageSize?: number, patientIn?: Array<number>, practiceIn?: Array<number>, search?: string, sessionTypeIn?: Array<'INDIVIDUAL_SESSION' | 'INITIAL_CONSULTATION'>, startDateFrom?: string, startDateTo?: string, therapistIn?: Array<number>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (appointmentStatusIn) {
            appointmentStatusIn.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'appointment_status_in');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>aroundNow, 'around_now');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page_size');
        if (patientIn) {
            patientIn.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'patient_in');
            })
        }
        if (practiceIn) {
            practiceIn.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'practice_in');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>search, 'search');
        if (sessionTypeIn) {
            sessionTypeIn.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'session_type_in');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startDateFrom, 'start_date_from');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startDateTo, 'start_date_to');
        if (therapistIn) {
            therapistIn.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'therapist_in');
            })
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/appointments/ids/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ListIds>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List appointments.
     * @param appointmentStatusIn 
     * @param aroundNow When true and no date range is set, the first page starts at the next upcoming appointment. Use previous/next cursors to load future and past. Ignored when a cursor or start_date_from/start_date_to is present.
     * @param cursor Der Zeigerwert für die Paginierung
     * @param pageSize Anzahl der pro Seite zurückzugebenden Ergebnisse.
     * @param patientIn 
     * @param practiceIn 
     * @param search 
     * @param sessionTypeIn 
     * @param startDateFrom Inclusive.
     * @param startDateTo Inclusive.
     * @param therapistIn 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingAppointmentsList(appointmentStatusIn?: Array<'ATTENDED' | 'BOOKED' | 'CANCELLED' | 'CANCELLED_LATE' | 'CANCELLED_PENDING' | 'RESERVED'>, aroundNow?: boolean, cursor?: string, pageSize?: number, patientIn?: Array<number>, practiceIn?: Array<number>, search?: string, sessionTypeIn?: Array<'INDIVIDUAL_SESSION' | 'INITIAL_CONSULTATION'>, startDateFrom?: string, startDateTo?: string, therapistIn?: Array<number>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PaginatedAppointmentListList>;
    public bookingAppointmentsList(appointmentStatusIn?: Array<'ATTENDED' | 'BOOKED' | 'CANCELLED' | 'CANCELLED_LATE' | 'CANCELLED_PENDING' | 'RESERVED'>, aroundNow?: boolean, cursor?: string, pageSize?: number, patientIn?: Array<number>, practiceIn?: Array<number>, search?: string, sessionTypeIn?: Array<'INDIVIDUAL_SESSION' | 'INITIAL_CONSULTATION'>, startDateFrom?: string, startDateTo?: string, therapistIn?: Array<number>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PaginatedAppointmentListList>>;
    public bookingAppointmentsList(appointmentStatusIn?: Array<'ATTENDED' | 'BOOKED' | 'CANCELLED' | 'CANCELLED_LATE' | 'CANCELLED_PENDING' | 'RESERVED'>, aroundNow?: boolean, cursor?: string, pageSize?: number, patientIn?: Array<number>, practiceIn?: Array<number>, search?: string, sessionTypeIn?: Array<'INDIVIDUAL_SESSION' | 'INITIAL_CONSULTATION'>, startDateFrom?: string, startDateTo?: string, therapistIn?: Array<number>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PaginatedAppointmentListList>>;
    public bookingAppointmentsList(appointmentStatusIn?: Array<'ATTENDED' | 'BOOKED' | 'CANCELLED' | 'CANCELLED_LATE' | 'CANCELLED_PENDING' | 'RESERVED'>, aroundNow?: boolean, cursor?: string, pageSize?: number, patientIn?: Array<number>, practiceIn?: Array<number>, search?: string, sessionTypeIn?: Array<'INDIVIDUAL_SESSION' | 'INITIAL_CONSULTATION'>, startDateFrom?: string, startDateTo?: string, therapistIn?: Array<number>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (appointmentStatusIn) {
            appointmentStatusIn.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'appointment_status_in');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>aroundNow, 'around_now');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>cursor, 'cursor');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page_size');
        if (patientIn) {
            patientIn.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'patient_in');
            })
        }
        if (practiceIn) {
            practiceIn.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'practice_in');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>search, 'search');
        if (sessionTypeIn) {
            sessionTypeIn.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'session_type_in');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startDateFrom, 'start_date_from');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startDateTo, 'start_date_to');
        if (therapistIn) {
            therapistIn.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'therapist_in');
            })
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/appointments/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PaginatedAppointmentListList>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return future appointments and blockers for the resource (calendar overlay).
     * @param appointmentResourceId 
     * @param fromDate Start of visible range (inclusive)
     * @param toDate End of visible range (exclusive)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingAvailabilityBackgroundEventsRetrieve(appointmentResourceId: number, fromDate?: string, toDate?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BackgroundEventsResult>;
    public bookingAvailabilityBackgroundEventsRetrieve(appointmentResourceId: number, fromDate?: string, toDate?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BackgroundEventsResult>>;
    public bookingAvailabilityBackgroundEventsRetrieve(appointmentResourceId: number, fromDate?: string, toDate?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BackgroundEventsResult>>;
    public bookingAvailabilityBackgroundEventsRetrieve(appointmentResourceId: number, fromDate?: string, toDate?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (appointmentResourceId === null || appointmentResourceId === undefined) {
            throw new Error('Required parameter appointmentResourceId was null or undefined when calling bookingAvailabilityBackgroundEventsRetrieve.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>fromDate, 'from_date');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>toDate, 'to_date');

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/availability/${this.configuration.encodeParam({name: "appointmentResourceId", value: appointmentResourceId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/background-events/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BackgroundEventsResult>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return booked appointments that fall outside any availability window.
     * @param appointmentResourceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingAvailabilityConflictsList(appointmentResourceId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<ConflictingAppointment>>;
    public bookingAvailabilityConflictsList(appointmentResourceId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<ConflictingAppointment>>>;
    public bookingAvailabilityConflictsList(appointmentResourceId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<ConflictingAppointment>>>;
    public bookingAvailabilityConflictsList(appointmentResourceId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (appointmentResourceId === null || appointmentResourceId === undefined) {
            throw new Error('Required parameter appointmentResourceId was null or undefined when calling bookingAvailabilityConflictsList.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/availability/${this.configuration.encodeParam({name: "appointmentResourceId", value: appointmentResourceId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/conflicts/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<ConflictingAppointment>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List all schedules for a resource or create a new recurring schedule.
     * @param appointmentResourceId 
     * @param availabilityScheduleCreateRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingAvailabilitySchedulesCreate(appointmentResourceId: number, availabilityScheduleCreateRequest: AvailabilityScheduleCreateRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ScheduleCreateResult>;
    public bookingAvailabilitySchedulesCreate(appointmentResourceId: number, availabilityScheduleCreateRequest: AvailabilityScheduleCreateRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ScheduleCreateResult>>;
    public bookingAvailabilitySchedulesCreate(appointmentResourceId: number, availabilityScheduleCreateRequest: AvailabilityScheduleCreateRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ScheduleCreateResult>>;
    public bookingAvailabilitySchedulesCreate(appointmentResourceId: number, availabilityScheduleCreateRequest: AvailabilityScheduleCreateRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (appointmentResourceId === null || appointmentResourceId === undefined) {
            throw new Error('Required parameter appointmentResourceId was null or undefined when calling bookingAvailabilitySchedulesCreate.');
        }
        if (availabilityScheduleCreateRequest === null || availabilityScheduleCreateRequest === undefined) {
            throw new Error('Required parameter availabilityScheduleCreateRequest was null or undefined when calling bookingAvailabilitySchedulesCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/availability/${this.configuration.encodeParam({name: "appointmentResourceId", value: appointmentResourceId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/schedules/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ScheduleCreateResult>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: availabilityScheduleCreateRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update or delete an editor-created schedule.
     * @param appointmentResourceId 
     * @param scheduleId 
     * @param ignoreWarnings Acknowledge and proceed past overridable warnings (e.g. Doctolib sync disabled).
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingAvailabilitySchedulesDestroy(appointmentResourceId: number, scheduleId: number, ignoreWarnings?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public bookingAvailabilitySchedulesDestroy(appointmentResourceId: number, scheduleId: number, ignoreWarnings?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public bookingAvailabilitySchedulesDestroy(appointmentResourceId: number, scheduleId: number, ignoreWarnings?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public bookingAvailabilitySchedulesDestroy(appointmentResourceId: number, scheduleId: number, ignoreWarnings?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (appointmentResourceId === null || appointmentResourceId === undefined) {
            throw new Error('Required parameter appointmentResourceId was null or undefined when calling bookingAvailabilitySchedulesDestroy.');
        }
        if (scheduleId === null || scheduleId === undefined) {
            throw new Error('Required parameter scheduleId was null or undefined when calling bookingAvailabilitySchedulesDestroy.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>ignoreWarnings, 'ignore_warnings');

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/availability/${this.configuration.encodeParam({name: "appointmentResourceId", value: appointmentResourceId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/schedules/${this.configuration.encodeParam({name: "scheduleId", value: scheduleId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List all schedules for a resource or create a new recurring schedule.
     * @param appointmentResourceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingAvailabilitySchedulesList(appointmentResourceId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<AvailabilitySchedule>>;
    public bookingAvailabilitySchedulesList(appointmentResourceId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<AvailabilitySchedule>>>;
    public bookingAvailabilitySchedulesList(appointmentResourceId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<AvailabilitySchedule>>>;
    public bookingAvailabilitySchedulesList(appointmentResourceId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (appointmentResourceId === null || appointmentResourceId === undefined) {
            throw new Error('Required parameter appointmentResourceId was null or undefined when calling bookingAvailabilitySchedulesList.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/availability/${this.configuration.encodeParam({name: "appointmentResourceId", value: appointmentResourceId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/schedules/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<AvailabilitySchedule>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update or delete an editor-created schedule.
     * @param appointmentResourceId 
     * @param scheduleId 
     * @param patchedAvailabilityScheduleUpdateRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingAvailabilitySchedulesPartialUpdate(appointmentResourceId: number, scheduleId: number, patchedAvailabilityScheduleUpdateRequest?: PatchedAvailabilityScheduleUpdateRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ScheduleCreateResult>;
    public bookingAvailabilitySchedulesPartialUpdate(appointmentResourceId: number, scheduleId: number, patchedAvailabilityScheduleUpdateRequest?: PatchedAvailabilityScheduleUpdateRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ScheduleCreateResult>>;
    public bookingAvailabilitySchedulesPartialUpdate(appointmentResourceId: number, scheduleId: number, patchedAvailabilityScheduleUpdateRequest?: PatchedAvailabilityScheduleUpdateRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ScheduleCreateResult>>;
    public bookingAvailabilitySchedulesPartialUpdate(appointmentResourceId: number, scheduleId: number, patchedAvailabilityScheduleUpdateRequest?: PatchedAvailabilityScheduleUpdateRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (appointmentResourceId === null || appointmentResourceId === undefined) {
            throw new Error('Required parameter appointmentResourceId was null or undefined when calling bookingAvailabilitySchedulesPartialUpdate.');
        }
        if (scheduleId === null || scheduleId === undefined) {
            throw new Error('Required parameter scheduleId was null or undefined when calling bookingAvailabilitySchedulesPartialUpdate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/availability/${this.configuration.encodeParam({name: "appointmentResourceId", value: appointmentResourceId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/schedules/${this.configuration.encodeParam({name: "scheduleId", value: scheduleId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ScheduleCreateResult>('patch', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: patchedAvailabilityScheduleUpdateRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Atomically end old schedule at event_date and create a new schedule from event_date.
     * @param appointmentResourceId 
     * @param scheduleId 
     * @param scheduleSplitRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingAvailabilitySchedulesSplitCreate(appointmentResourceId: number, scheduleId: number, scheduleSplitRequest: ScheduleSplitRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ScheduleCreateResult>;
    public bookingAvailabilitySchedulesSplitCreate(appointmentResourceId: number, scheduleId: number, scheduleSplitRequest: ScheduleSplitRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ScheduleCreateResult>>;
    public bookingAvailabilitySchedulesSplitCreate(appointmentResourceId: number, scheduleId: number, scheduleSplitRequest: ScheduleSplitRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ScheduleCreateResult>>;
    public bookingAvailabilitySchedulesSplitCreate(appointmentResourceId: number, scheduleId: number, scheduleSplitRequest: ScheduleSplitRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (appointmentResourceId === null || appointmentResourceId === undefined) {
            throw new Error('Required parameter appointmentResourceId was null or undefined when calling bookingAvailabilitySchedulesSplitCreate.');
        }
        if (scheduleId === null || scheduleId === undefined) {
            throw new Error('Required parameter scheduleId was null or undefined when calling bookingAvailabilitySchedulesSplitCreate.');
        }
        if (scheduleSplitRequest === null || scheduleSplitRequest === undefined) {
            throw new Error('Required parameter scheduleSplitRequest was null or undefined when calling bookingAvailabilitySchedulesSplitCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/availability/${this.configuration.encodeParam({name: "appointmentResourceId", value: appointmentResourceId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/schedules/${this.configuration.encodeParam({name: "scheduleId", value: scheduleId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/split/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ScheduleCreateResult>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: scheduleSplitRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return weekly utilization stats for a resource.
     * @param appointmentResourceId 
     * @param fromDate Start date (defaults to Monday of current ISO week)
     * @param weeks Number of weeks (default 16)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingAvailabilityWeeklyStatsList(appointmentResourceId: number, fromDate?: string, weeks?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<WeeklyUtilizationResult>>;
    public bookingAvailabilityWeeklyStatsList(appointmentResourceId: number, fromDate?: string, weeks?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<WeeklyUtilizationResult>>>;
    public bookingAvailabilityWeeklyStatsList(appointmentResourceId: number, fromDate?: string, weeks?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<WeeklyUtilizationResult>>>;
    public bookingAvailabilityWeeklyStatsList(appointmentResourceId: number, fromDate?: string, weeks?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (appointmentResourceId === null || appointmentResourceId === undefined) {
            throw new Error('Required parameter appointmentResourceId was null or undefined when calling bookingAvailabilityWeeklyStatsList.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>fromDate, 'from_date');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>weeks, 'weeks');

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/availability/${this.configuration.encodeParam({name: "appointmentResourceId", value: appointmentResourceId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/weekly-stats/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<WeeklyUtilizationResult>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Atomically turn a one-off window into a recurring schedule.  The schedule repeats on the window\&#39;s own weekday, starting from the window\&#39;s date (so the original date becomes the series\&#39; first occurrence). The one-off window is soft-deleted and replaced by the schedule\&#39;s expanded windows in a single transaction.
     * @param appointmentResourceId 
     * @param windowId 
     * @param windowToScheduleRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingAvailabilityWindowsConvertToScheduleCreate(appointmentResourceId: number, windowId: number, windowToScheduleRequest: WindowToScheduleRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ScheduleCreateResult>;
    public bookingAvailabilityWindowsConvertToScheduleCreate(appointmentResourceId: number, windowId: number, windowToScheduleRequest: WindowToScheduleRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ScheduleCreateResult>>;
    public bookingAvailabilityWindowsConvertToScheduleCreate(appointmentResourceId: number, windowId: number, windowToScheduleRequest: WindowToScheduleRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ScheduleCreateResult>>;
    public bookingAvailabilityWindowsConvertToScheduleCreate(appointmentResourceId: number, windowId: number, windowToScheduleRequest: WindowToScheduleRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (appointmentResourceId === null || appointmentResourceId === undefined) {
            throw new Error('Required parameter appointmentResourceId was null or undefined when calling bookingAvailabilityWindowsConvertToScheduleCreate.');
        }
        if (windowId === null || windowId === undefined) {
            throw new Error('Required parameter windowId was null or undefined when calling bookingAvailabilityWindowsConvertToScheduleCreate.');
        }
        if (windowToScheduleRequest === null || windowToScheduleRequest === undefined) {
            throw new Error('Required parameter windowToScheduleRequest was null or undefined when calling bookingAvailabilityWindowsConvertToScheduleCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/availability/${this.configuration.encodeParam({name: "appointmentResourceId", value: appointmentResourceId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/windows/${this.configuration.encodeParam({name: "windowId", value: windowId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/convert-to-schedule/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ScheduleCreateResult>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: windowToScheduleRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List windows for a resource (date-range filtered) or create a one-off window.
     * @param appointmentResourceId 
     * @param availabilityWindowCreateRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingAvailabilityWindowsCreate(appointmentResourceId: number, availabilityWindowCreateRequest: AvailabilityWindowCreateRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<AvailabilityWindow>;
    public bookingAvailabilityWindowsCreate(appointmentResourceId: number, availabilityWindowCreateRequest: AvailabilityWindowCreateRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AvailabilityWindow>>;
    public bookingAvailabilityWindowsCreate(appointmentResourceId: number, availabilityWindowCreateRequest: AvailabilityWindowCreateRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AvailabilityWindow>>;
    public bookingAvailabilityWindowsCreate(appointmentResourceId: number, availabilityWindowCreateRequest: AvailabilityWindowCreateRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (appointmentResourceId === null || appointmentResourceId === undefined) {
            throw new Error('Required parameter appointmentResourceId was null or undefined when calling bookingAvailabilityWindowsCreate.');
        }
        if (availabilityWindowCreateRequest === null || availabilityWindowCreateRequest === undefined) {
            throw new Error('Required parameter availabilityWindowCreateRequest was null or undefined when calling bookingAvailabilityWindowsCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/availability/${this.configuration.encodeParam({name: "appointmentResourceId", value: appointmentResourceId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/windows/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AvailabilityWindow>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: availabilityWindowCreateRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update, detach, or delete a single availability window.
     * @param appointmentResourceId 
     * @param windowId 
     * @param ignoreWarnings Acknowledge and proceed past overridable warnings (e.g. Doctolib sync disabled).
     * @param scope Deletion scope: THIS_ONLY (default) or THIS_AND_FUTURE.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingAvailabilityWindowsDestroy(appointmentResourceId: number, windowId: number, ignoreWarnings?: boolean, scope?: 'THIS_AND_FUTURE' | 'THIS_ONLY', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public bookingAvailabilityWindowsDestroy(appointmentResourceId: number, windowId: number, ignoreWarnings?: boolean, scope?: 'THIS_AND_FUTURE' | 'THIS_ONLY', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public bookingAvailabilityWindowsDestroy(appointmentResourceId: number, windowId: number, ignoreWarnings?: boolean, scope?: 'THIS_AND_FUTURE' | 'THIS_ONLY', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public bookingAvailabilityWindowsDestroy(appointmentResourceId: number, windowId: number, ignoreWarnings?: boolean, scope?: 'THIS_AND_FUTURE' | 'THIS_ONLY', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (appointmentResourceId === null || appointmentResourceId === undefined) {
            throw new Error('Required parameter appointmentResourceId was null or undefined when calling bookingAvailabilityWindowsDestroy.');
        }
        if (windowId === null || windowId === undefined) {
            throw new Error('Required parameter windowId was null or undefined when calling bookingAvailabilityWindowsDestroy.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>ignoreWarnings, 'ignore_warnings');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>scope, 'scope');

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/availability/${this.configuration.encodeParam({name: "appointmentResourceId", value: appointmentResourceId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/windows/${this.configuration.encodeParam({name: "windowId", value: windowId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Detach a window from its schedule, making it a standalone one-off.
     * @param appointmentResourceId 
     * @param windowId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingAvailabilityWindowsDetachCreate(appointmentResourceId: number, windowId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<AvailabilityWindow>;
    public bookingAvailabilityWindowsDetachCreate(appointmentResourceId: number, windowId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AvailabilityWindow>>;
    public bookingAvailabilityWindowsDetachCreate(appointmentResourceId: number, windowId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AvailabilityWindow>>;
    public bookingAvailabilityWindowsDetachCreate(appointmentResourceId: number, windowId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (appointmentResourceId === null || appointmentResourceId === undefined) {
            throw new Error('Required parameter appointmentResourceId was null or undefined when calling bookingAvailabilityWindowsDetachCreate.');
        }
        if (windowId === null || windowId === undefined) {
            throw new Error('Required parameter windowId was null or undefined when calling bookingAvailabilityWindowsDetachCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/availability/${this.configuration.encodeParam({name: "appointmentResourceId", value: appointmentResourceId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/windows/${this.configuration.encodeParam({name: "windowId", value: windowId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/detach/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AvailabilityWindow>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Atomically detach a window from its schedule and update its fields.
     * @param appointmentResourceId 
     * @param windowId 
     * @param availabilityWindowUpdateRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingAvailabilityWindowsDetachUpdateCreate(appointmentResourceId: number, windowId: number, availabilityWindowUpdateRequest?: AvailabilityWindowUpdateRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<AvailabilityWindow>;
    public bookingAvailabilityWindowsDetachUpdateCreate(appointmentResourceId: number, windowId: number, availabilityWindowUpdateRequest?: AvailabilityWindowUpdateRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AvailabilityWindow>>;
    public bookingAvailabilityWindowsDetachUpdateCreate(appointmentResourceId: number, windowId: number, availabilityWindowUpdateRequest?: AvailabilityWindowUpdateRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AvailabilityWindow>>;
    public bookingAvailabilityWindowsDetachUpdateCreate(appointmentResourceId: number, windowId: number, availabilityWindowUpdateRequest?: AvailabilityWindowUpdateRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (appointmentResourceId === null || appointmentResourceId === undefined) {
            throw new Error('Required parameter appointmentResourceId was null or undefined when calling bookingAvailabilityWindowsDetachUpdateCreate.');
        }
        if (windowId === null || windowId === undefined) {
            throw new Error('Required parameter windowId was null or undefined when calling bookingAvailabilityWindowsDetachUpdateCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/availability/${this.configuration.encodeParam({name: "appointmentResourceId", value: appointmentResourceId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/windows/${this.configuration.encodeParam({name: "windowId", value: windowId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/detach-update/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AvailabilityWindow>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: availabilityWindowUpdateRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List windows for a resource (date-range filtered) or create a one-off window.
     * @param appointmentResourceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingAvailabilityWindowsList(appointmentResourceId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<AvailabilityWindow>>;
    public bookingAvailabilityWindowsList(appointmentResourceId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<AvailabilityWindow>>>;
    public bookingAvailabilityWindowsList(appointmentResourceId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<AvailabilityWindow>>>;
    public bookingAvailabilityWindowsList(appointmentResourceId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (appointmentResourceId === null || appointmentResourceId === undefined) {
            throw new Error('Required parameter appointmentResourceId was null or undefined when calling bookingAvailabilityWindowsList.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/availability/${this.configuration.encodeParam({name: "appointmentResourceId", value: appointmentResourceId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/windows/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<AvailabilityWindow>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update, detach, or delete a single availability window.
     * @param appointmentResourceId 
     * @param windowId 
     * @param patchedAvailabilityWindowUpdateRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingAvailabilityWindowsPartialUpdate(appointmentResourceId: number, windowId: number, patchedAvailabilityWindowUpdateRequest?: PatchedAvailabilityWindowUpdateRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<AvailabilityWindow>;
    public bookingAvailabilityWindowsPartialUpdate(appointmentResourceId: number, windowId: number, patchedAvailabilityWindowUpdateRequest?: PatchedAvailabilityWindowUpdateRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AvailabilityWindow>>;
    public bookingAvailabilityWindowsPartialUpdate(appointmentResourceId: number, windowId: number, patchedAvailabilityWindowUpdateRequest?: PatchedAvailabilityWindowUpdateRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AvailabilityWindow>>;
    public bookingAvailabilityWindowsPartialUpdate(appointmentResourceId: number, windowId: number, patchedAvailabilityWindowUpdateRequest?: PatchedAvailabilityWindowUpdateRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (appointmentResourceId === null || appointmentResourceId === undefined) {
            throw new Error('Required parameter appointmentResourceId was null or undefined when calling bookingAvailabilityWindowsPartialUpdate.');
        }
        if (windowId === null || windowId === undefined) {
            throw new Error('Required parameter windowId was null or undefined when calling bookingAvailabilityWindowsPartialUpdate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/availability/${this.configuration.encodeParam({name: "appointmentResourceId", value: appointmentResourceId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/windows/${this.configuration.encodeParam({name: "windowId", value: windowId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AvailabilityWindow>('patch', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: patchedAvailabilityWindowUpdateRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Book an appointment of the appointment type for the given patient and therapist.
     * @param calendarAppointmentBook 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingCalendarAppointmentBookCreate(calendarAppointmentBook: CalendarAppointmentBook, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public bookingCalendarAppointmentBookCreate(calendarAppointmentBook: CalendarAppointmentBook, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public bookingCalendarAppointmentBookCreate(calendarAppointmentBook: CalendarAppointmentBook, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public bookingCalendarAppointmentBookCreate(calendarAppointmentBook: CalendarAppointmentBook, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (calendarAppointmentBook === null || calendarAppointmentBook === undefined) {
            throw new Error('Required parameter calendarAppointmentBook was null or undefined when calling bookingCalendarAppointmentBookCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/calendar/appointment/book/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: calendarAppointmentBook,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve values for the appointment book drawer.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingCalendarAppointmentBookRetrieve(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CalendarAppointmentBookGet>;
    public bookingCalendarAppointmentBookRetrieve(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CalendarAppointmentBookGet>>;
    public bookingCalendarAppointmentBookRetrieve(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CalendarAppointmentBookGet>>;
    public bookingCalendarAppointmentBookRetrieve(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/calendar/appointment/book/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CalendarAppointmentBookGet>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Queue async task to send confirmation email. Toast notification via WebSocket.
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingCalendarAppointmentConfirmRetrieve(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public bookingCalendarAppointmentConfirmRetrieve(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public bookingCalendarAppointmentConfirmRetrieve(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public bookingCalendarAppointmentConfirmRetrieve(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling bookingCalendarAppointmentConfirmRetrieve.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/calendar/appointment/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/confirm`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Which appointments the calendar shows for the same request, without building them (rule angular-list-refresh).
     * @param calendarRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingCalendarAppointmentIdsCreate(calendarRequest: CalendarRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ListIds>;
    public bookingCalendarAppointmentIdsCreate(calendarRequest: CalendarRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ListIds>>;
    public bookingCalendarAppointmentIdsCreate(calendarRequest: CalendarRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ListIds>>;
    public bookingCalendarAppointmentIdsCreate(calendarRequest: CalendarRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (calendarRequest === null || calendarRequest === undefined) {
            throw new Error('Required parameter calendarRequest was null or undefined when calling bookingCalendarAppointmentIdsCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/calendar/appointment-ids/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ListIds>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: calendarRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update the appointment with the given id.
     * @param id 
     * @param patchedCalendarAppointmentUpdate 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingCalendarAppointmentPartialUpdate(id: number, patchedCalendarAppointmentUpdate?: PatchedCalendarAppointmentUpdate, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public bookingCalendarAppointmentPartialUpdate(id: number, patchedCalendarAppointmentUpdate?: PatchedCalendarAppointmentUpdate, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public bookingCalendarAppointmentPartialUpdate(id: number, patchedCalendarAppointmentUpdate?: PatchedCalendarAppointmentUpdate, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public bookingCalendarAppointmentPartialUpdate(id: number, patchedCalendarAppointmentUpdate?: PatchedCalendarAppointmentUpdate, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling bookingCalendarAppointmentPartialUpdate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/calendar/appointment/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('patch', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: patchedCalendarAppointmentUpdate,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Regenerate the video link for the appointment with the given id.
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingCalendarAppointmentRegenerateRetrieve(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public bookingCalendarAppointmentRegenerateRetrieve(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public bookingCalendarAppointmentRegenerateRetrieve(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public bookingCalendarAppointmentRegenerateRetrieve(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling bookingCalendarAppointmentRegenerateRetrieve.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/calendar/appointment/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/regenerate`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve the details of the appointment with the given id.
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingCalendarAppointmentRetrieve(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<AppointmentSerializerDetail>;
    public bookingCalendarAppointmentRetrieve(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AppointmentSerializerDetail>>;
    public bookingCalendarAppointmentRetrieve(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AppointmentSerializerDetail>>;
    public bookingCalendarAppointmentRetrieve(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling bookingCalendarAppointmentRetrieve.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/calendar/appointment/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AppointmentSerializerDetail>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Redirect to the video call for the appointment with the given id.
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingCalendarAppointmentVideoCallRetrieve(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CalendarAppointmentVideoCallLinkResponse>;
    public bookingCalendarAppointmentVideoCallRetrieve(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CalendarAppointmentVideoCallLinkResponse>>;
    public bookingCalendarAppointmentVideoCallRetrieve(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CalendarAppointmentVideoCallLinkResponse>>;
    public bookingCalendarAppointmentVideoCallRetrieve(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling bookingCalendarAppointmentVideoCallRetrieve.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/calendar/appointment/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/video-call`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CalendarAppointmentVideoCallLinkResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a blocker or blocker series for the given appointment resource. The determining field for whether to create a blocker or blocker series is the week interval. If the week interval is provided and not 0, a blocker series will be created. If the week interval is not provided or 0, a single blocker will be created.
     * @param calendarBlockerCreate 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingCalendarBlockerCreateCreate(calendarBlockerCreate: CalendarBlockerCreate, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public bookingCalendarBlockerCreateCreate(calendarBlockerCreate: CalendarBlockerCreate, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public bookingCalendarBlockerCreateCreate(calendarBlockerCreate: CalendarBlockerCreate, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public bookingCalendarBlockerCreateCreate(calendarBlockerCreate: CalendarBlockerCreate, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (calendarBlockerCreate === null || calendarBlockerCreate === undefined) {
            throw new Error('Required parameter calendarBlockerCreate was null or undefined when calling bookingCalendarBlockerCreateCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/calendar/blocker/create/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: calendarBlockerCreate,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve a list of blocker types.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingCalendarBlockerCreateRetrieve(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CalendarBlockerInitial>;
    public bookingCalendarBlockerCreateRetrieve(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CalendarBlockerInitial>>;
    public bookingCalendarBlockerCreateRetrieve(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CalendarBlockerInitial>>;
    public bookingCalendarBlockerCreateRetrieve(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/calendar/blocker/create/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CalendarBlockerInitial>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Archive the blocker with the given id.
     * @param id 
     * @param archiveSeries 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingCalendarBlockerDestroy(id: number, archiveSeries?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public bookingCalendarBlockerDestroy(id: number, archiveSeries?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public bookingCalendarBlockerDestroy(id: number, archiveSeries?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public bookingCalendarBlockerDestroy(id: number, archiveSeries?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling bookingCalendarBlockerDestroy.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>archiveSeries, 'archive_series');

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/calendar/blocker/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update the blocker with the given id.
     * @param id 
     * @param patchedAppointmentBlockerUpdate 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingCalendarBlockerPartialUpdate(id: number, patchedAppointmentBlockerUpdate?: PatchedAppointmentBlockerUpdate, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public bookingCalendarBlockerPartialUpdate(id: number, patchedAppointmentBlockerUpdate?: PatchedAppointmentBlockerUpdate, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public bookingCalendarBlockerPartialUpdate(id: number, patchedAppointmentBlockerUpdate?: PatchedAppointmentBlockerUpdate, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public bookingCalendarBlockerPartialUpdate(id: number, patchedAppointmentBlockerUpdate?: PatchedAppointmentBlockerUpdate, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling bookingCalendarBlockerPartialUpdate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/calendar/blocker/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('patch', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: patchedAppointmentBlockerUpdate,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve the details of the blocker with the given id.
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingCalendarBlockerRetrieve(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<AppointmentBlocker>;
    public bookingCalendarBlockerRetrieve(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AppointmentBlocker>>;
    public bookingCalendarBlockerRetrieve(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AppointmentBlocker>>;
    public bookingCalendarBlockerRetrieve(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling bookingCalendarBlockerRetrieve.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/calendar/blocker/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AppointmentBlocker>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve a list of appointments and blockers for the given therapists in the given date range.
     * @param calendarRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingCalendarCreate(calendarRequest: CalendarRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CalendarResponse>;
    public bookingCalendarCreate(calendarRequest: CalendarRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CalendarResponse>>;
    public bookingCalendarCreate(calendarRequest: CalendarRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CalendarResponse>>;
    public bookingCalendarCreate(calendarRequest: CalendarRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (calendarRequest === null || calendarRequest === undefined) {
            throw new Error('Required parameter calendarRequest was null or undefined when calling bookingCalendarCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/calendar/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CalendarResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: calendarRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve the initial values for the filterbox.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingCalendarFilterRetrieve(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CalendarFilterResponse>;
    public bookingCalendarFilterRetrieve(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CalendarFilterResponse>>;
    public bookingCalendarFilterRetrieve(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CalendarFilterResponse>>;
    public bookingCalendarFilterRetrieve(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/calendar/filter/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CalendarFilterResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Expose runtime booking configuration to the frontend.  The planning horizon (&#x60;&#x60;BOOKING_SLOTS_RANGE_IN_DAYS&#x60;&#x60;) and display toggles, so the planner calendar and the availability page read the runtime Constance values instead of hardcoding them.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingConfigRetrieve(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BookingConfig>;
    public bookingConfigRetrieve(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BookingConfig>>;
    public bookingConfigRetrieve(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BookingConfig>>;
    public bookingConfigRetrieve(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/config/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BookingConfig>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * APIView for retrieving all appointment types that are valid for the given filter criteria.
     * @param appointmentTypeFilter 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingFilterAppointmentTypeCreate(appointmentTypeFilter: AppointmentTypeFilter, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<AppointmentType>>;
    public bookingFilterAppointmentTypeCreate(appointmentTypeFilter: AppointmentTypeFilter, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<AppointmentType>>>;
    public bookingFilterAppointmentTypeCreate(appointmentTypeFilter: AppointmentTypeFilter, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<AppointmentType>>>;
    public bookingFilterAppointmentTypeCreate(appointmentTypeFilter: AppointmentTypeFilter, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (appointmentTypeFilter === null || appointmentTypeFilter === undefined) {
            throw new Error('Required parameter appointmentTypeFilter was null or undefined when calling bookingFilterAppointmentTypeCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/filter/appointment-type/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<AppointmentType>>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: appointmentTypeFilter,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve all treatment types available for a patient based on their organizations.
     * @param treatmentTypeFilter 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingFilterTreatmentTypeCreate(treatmentTypeFilter: TreatmentTypeFilter, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TreatmentType>;
    public bookingFilterTreatmentTypeCreate(treatmentTypeFilter: TreatmentTypeFilter, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TreatmentType>>;
    public bookingFilterTreatmentTypeCreate(treatmentTypeFilter: TreatmentTypeFilter, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TreatmentType>>;
    public bookingFilterTreatmentTypeCreate(treatmentTypeFilter: TreatmentTypeFilter, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (treatmentTypeFilter === null || treatmentTypeFilter === undefined) {
            throw new Error('Required parameter treatmentTypeFilter was null or undefined when calling bookingFilterTreatmentTypeCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/filter/treatment-type/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TreatmentType>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: treatmentTypeFilter,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create an appointment for the given patient, appointment type and booking slot. This attempts to create an appointment object in the database, sync it with the video call provider and Zoho Creator, and send a confirmation email to the patient.
     * @param plannerBookingViewRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingPlannerBookCreate(plannerBookingViewRequest: PlannerBookingViewRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public bookingPlannerBookCreate(plannerBookingViewRequest: PlannerBookingViewRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public bookingPlannerBookCreate(plannerBookingViewRequest: PlannerBookingViewRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public bookingPlannerBookCreate(plannerBookingViewRequest: PlannerBookingViewRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (plannerBookingViewRequest === null || plannerBookingViewRequest === undefined) {
            throw new Error('Required parameter plannerBookingViewRequest was null or undefined when calling bookingPlannerBookCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/planner/book/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: plannerBookingViewRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve available slots for the given day, therapists, and appointment types.
     * @param plannerCalendarViewRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingPlannerCalendarCreate(plannerCalendarViewRequest: PlannerCalendarViewRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<PlannerCalendarViewResponse>>;
    public bookingPlannerCalendarCreate(plannerCalendarViewRequest: PlannerCalendarViewRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<PlannerCalendarViewResponse>>>;
    public bookingPlannerCalendarCreate(plannerCalendarViewRequest: PlannerCalendarViewRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<PlannerCalendarViewResponse>>>;
    public bookingPlannerCalendarCreate(plannerCalendarViewRequest: PlannerCalendarViewRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (plannerCalendarViewRequest === null || plannerCalendarViewRequest === undefined) {
            throw new Error('Required parameter plannerCalendarViewRequest was null or undefined when calling bookingPlannerCalendarCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/planner/calendar/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<PlannerCalendarViewResponse>>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: plannerCalendarViewRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve a list of dates with available slots for the given therapists and appointment types.
     * @param plannerViewRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingPlannerCreate(plannerViewRequest: PlannerViewRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<string>>;
    public bookingPlannerCreate(plannerViewRequest: PlannerViewRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<string>>>;
    public bookingPlannerCreate(plannerViewRequest: PlannerViewRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<string>>>;
    public bookingPlannerCreate(plannerViewRequest: PlannerViewRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (plannerViewRequest === null || plannerViewRequest === undefined) {
            throw new Error('Required parameter plannerViewRequest was null or undefined when calling bookingPlannerCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/planner/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<string>>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: plannerViewRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve the initial values for the filterbox.  When a patient_id is provided, practices are scoped to those belonging to the patient\&#39;s organizations.
     * @param plannerFilterRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingPlannerFilterCreate(plannerFilterRequest?: PlannerFilterRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PlannerFilterViewResponse>;
    public bookingPlannerFilterCreate(plannerFilterRequest?: PlannerFilterRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PlannerFilterViewResponse>>;
    public bookingPlannerFilterCreate(plannerFilterRequest?: PlannerFilterRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PlannerFilterViewResponse>>;
    public bookingPlannerFilterCreate(plannerFilterRequest?: PlannerFilterRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/planner/filter/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PlannerFilterViewResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: plannerFilterRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Whether the patient already has a booked/attended initial consultation in any of their organizations.  Independent of the appointment types the planner currently offers, so the warning also shows when the selected therapist has no bookable initial consultation type.
     * @param plannerInitialConsultationCheckRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookingPlannerInitialConsultationCheckCreate(plannerInitialConsultationCheckRequest: PlannerInitialConsultationCheckRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PlannerInitialConsultationCheckResponse>;
    public bookingPlannerInitialConsultationCheckCreate(plannerInitialConsultationCheckRequest: PlannerInitialConsultationCheckRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PlannerInitialConsultationCheckResponse>>;
    public bookingPlannerInitialConsultationCheckCreate(plannerInitialConsultationCheckRequest: PlannerInitialConsultationCheckRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PlannerInitialConsultationCheckResponse>>;
    public bookingPlannerInitialConsultationCheckCreate(plannerInitialConsultationCheckRequest: PlannerInitialConsultationCheckRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (plannerInitialConsultationCheckRequest === null || plannerInitialConsultationCheckRequest === undefined) {
            throw new Error('Required parameter plannerInitialConsultationCheckRequest was null or undefined when calling bookingPlannerInitialConsultationCheckCreate.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        // authentication (tokenAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('tokenAuth', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/x-www-form-urlencoded',
            'multipart/form-data'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/booking/planner/initial-consultation-check/`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PlannerInitialConsultationCheckResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: plannerInitialConsultationCheckRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
